const SITE_CONFIG = {
  /* ─────────────────────────────────────────────
     BRAND
  ───────────────────────────────────────────── */
  siteName: "Ghar Ka Organic",

  siteTagline:
    "Authentic Himalayan Organic Food from Uttarakhand",

  baseUrl: "https://gharkaorganic.com",

  canonical: "https://gharkaorganic.com",

  language: "en-IN",

  themeColor: "#ffffff",

  currency: "INR",

  /* ─────────────────────────────────────────────
     CONTACT
  ───────────────────────────────────────────── */
  phone: "+91 9897447525",

  whatsapp: "+91 9897447525",

  email: "gharkaorganic@gmail.com",

  instagram: "https://www.instagram.com/gharkaorganic/",

  /* ─────────────────────────────────────────────
     ADDRESS
  ───────────────────────────────────────────── */
  address: {
    street: "Ward No. 2, Nalni",

    village: "Nainital",

    district: "Nainital",

    state: "Uttarakhand",

    postalCode: "263002",

    country: "India",

    countryCode: "IN",
  },

  /* ─────────────────────────────────────────────
     GEO
  ───────────────────────────────────────────── */
  geo: {
    latitude: 29.3459,

    longitude: 79.5618,
  },

  /* ─────────────────────────────────────────────
     MEDIA
  ───────────────────────────────────────────── */
  heroImage:
    "https://res.cloudinary.com/dwgro3zo7/image/upload/v1776768403/Local_women_in_Bhimtal_Uttarakhand_preparing_traditional_Himalayan_organic_food_tbpvgk.webp",

  ogImage:
    "https://res.cloudinary.com/dwgro3zo7/image/upload/v1776768403/Local_women_in_Bhimtal_Uttarakhand_preparing_traditional_Himalayan_organic_food_tbpvgk.webp",

  logo: "https://gharkaorganic.com/logo/gharka-logo.png",

  favicon: "/favicon.png",

  /* ─────────────────────────────────────────────
     BUSINESS INFO
  ───────────────────────────────────────────── */
  businessType: [
    "LocalBusiness",
    "FoodManufacturer",
    "OnlineStore",
  ],

  priceRange: "₹₹",

  areaServed: "India",

  /* ─────────────────────────────────────────────
     SEO KEYWORDS
  ───────────────────────────────────────────── */
  keywords: [
    "Ghar Ka Organic",
    "Himalayan Organic Products",
    "Pahadi Pickles",
    "Kumaoni Achar",
    "Raw Forest Honey",
    "Bilona Desi Ghee",
    "Organic Food India",
    "Traditional Uttarakhand Food",
    "Homemade Pickles Online",
    "Pahadi Honey",
    "Chemical Free Food",
    "Village Food Products",
  ],

  /* ─────────────────────────────────────────────
     SOCIAL LINKS
  ───────────────────────────────────────────── */
  socialLinks: {
    instagram: "https://www.instagram.com/gharkaorganic/",
  },

  /* ─────────────────────────────────────────────
     BUSINESS HOURS
  ───────────────────────────────────────────── */
  openingHours: {
    days: [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],

    opens: "10:00",

    closes: "19:00",
  },
};

export default SITE_CONFIG;